import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import { routePurchaseReceiptsRoot } from './purchaseReceiptsRoutes'
import { routeStockBalanceHome, routeStockBalanceRoot } from './stockBalanceRoutes'
import { routeStockEntriesRoot } from './stockEntriesRoutes'
import { routeWarehousesRoot } from './warehousesRoutes'

const routeStockHome: RouteRecordRaw = {
  name: 'stock-home',
  path: '',
  redirect: routeStockBalanceHome,
}

const routeStockRoot: RouteRecordRaw = {
  children: [
    routeStockHome,
    routeStockBalanceRoot,
    routeWarehousesRoot,
    routePurchaseReceiptsRoot,
    routeStockEntriesRoot,
  ],
  path: 'stock',
}

const redirectStock: RedirectRouteRelative = {
  name: routeStockHome.name,
}

export { redirectStock, routeStockRoot }
